module.exports = __webpack_public_path__ + "img/bg_custom2.b751a10c.jpg";